import { useState, useEffect } from "react";
import { useLocation } from "@reach/router";
export function useActiveLink(to: string) {
  const [isActive, setIsActive] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
     const regex = new RegExp(`(${to})+`);
     //console.log("active Link", to, pathname, regex, pathname.search(regex));

     const pathSearch = pathname.search(regex);

     let isActivePath = pathname === to ? true : to !== "/" && pathSearch >= 0;
     setIsActive(isActivePath);
    
  });

  return isActive;
}
